import { useEffect } from 'react';
import AppDBStorage from '@Services/AppDBStorage';
import AppStorage from '@Services/AppStorage';

const useAppInitialization = () => {
  useEffect(() => {
    // Storage cleanup
    AppStorage.instance.cleanUp();
    AppDBStorage.globalDBStorage.cleanUp();

    // Request notification permission
    if (window.Notification && Notification.permission !== 'denied') {
      Notification.requestPermission();
    }

    const scrollTo = (id, event) => {
      if (!event || event.which === 13) {
        const content = document.querySelector(`#${id}`);
        content.scrollIntoView({ behavior: 'smooth', block: 'start' });
        content.focus();
      }
    };
    window.scrollTo = scrollTo;
  }, []);
};

export default useAppInitialization;
